module.exports = __webpack_public_path__ + "static/img/045app下载页.2ad90db.png";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/045app下载页.png
// module id = /svq
// module chunks = 0